import React, { useRef, useState } from 'react';
import { AircraftPicker } from './ExaminerShared';

export default function ExaminerDocuments({ aircraft, request, run, busy, onUploaded }) {
  const [aircraftId, setAircraftId] = useState('');
  const [authorized, setAuthorized] = useState(false);
  const [consent, setConsent] = useState(false);
  const [result, setResult] = useState(null);
  const form = useRef(null);
  return <section aria-label="Aircraft document upload">
    <h3>Supply missing aircraft documents</h3>
    <p>Upload an authorized POH/AFM PDF or plain text (maximum 8 MiB). The original is stored privately in the organization library, outside the 30-day examination purge. Extraction may use provider OCR. An independent instructor must compare extracted text against the original and approve its applicability before you explicitly resume a stopped job. Pending review does not require another upload.</p>
    <form ref={form} onSubmit={event => {
      event.preventDefault();
      const body = new FormData(form.current);
      run(async () => {
        setResult(null);
        const file = body.get('document');
        if (!(file instanceof File) || !file.size || file.size > 8 * 1024 * 1024) throw new Error('Select a nonempty PDF or plain-text document no larger than 8 MiB.');
        if (!/(\.pdf|\.txt)$/i.test(file.name)) throw new Error('Select a PDF or plain-text document.');
        if (!aircraftId || !authorized || !consent) throw new Error('Select an aircraft and acknowledge upload authorization and processing consent.');
        body.set('authorizedToUpload', 'true');
        body.set('processingConsent', 'true');
        const data = await request(`/aircraft/${aircraftId}/documents`, { method: 'POST', body });
        setResult(data);
        form.current.reset(); setAuthorized(false); setConsent(false);
        await onUploaded();
      });
    }}>
      <fieldset disabled={busy}>
        <legend>Aircraft reference library</legend>
        <AircraftPicker aircraft={aircraft} value={aircraftId} onChange={setAircraftId} />
        <label>Document<input name="document" type="file" accept=".pdf,.txt,application/pdf,text/plain" required /></label>
        <label>Document title<input name="title" required /></label>
        <label>Document revision<input name="revision" required /></label>
        <label>Aircraft applicability<input name="applicability" required placeholder="Serial range, equipment and supplements" /></label>
        <label className="examiner-check"><input type="checkbox" checked={authorized} onChange={event => setAuthorized(event.target.checked)} />I am authorized to upload and store this document.</label>
        <label className="examiner-check"><input type="checkbox" checked={consent} onChange={event => setConsent(event.target.checked)} />I consent to private document storage and processing, including possible provider OCR.</label>
        <button type="submit" disabled={!authorized || !consent}>Upload aircraft document</button>
      </fieldset>
    </form>
    {result && <p role="status">Document {result.id} saved. Source references: {result.referenceIds?.join(', ')}. Independent instructor review is required; upload does not approve sources or resume stopped jobs.</p>}
  </section>;
}
